/**
 * Rocksoft Security API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OperationsFlags = {
    Create: 'Create',
    Read: 'Read',
    Update: 'Update',
    Delete: 'Delete',
} as const;
export type OperationsFlags = typeof OperationsFlags[keyof typeof OperationsFlags];

